function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.82 70.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4,.22C.86,1.32,0,3.9,0,12.26c0,5.5.52,9.36,1.51,11.28,1.06,2.06,1.66,7.31,2.02,17.7.69,20.01,2.91,29.28,7.02,29.28,2.38,0,3.14-3.56,3.86-18,.73-14.6,1.45-19.62,4.78-33.62,1.99-8.35,2.05-9.44.7-12.99-1.35-3.54-1.87-3.93-6.1-4.54-2.54-.36-5.45-.89-6.46-1.17-1.01-.28-2.51-.27-3.34.02",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.23,4.87c1.29,2.01.82,9.79-.92,15.31q-1.68,5.33-5.85,5.34c-7.21,0-8.25-2.37-7.69-17.37l.22-5.87,6.75.72c3.71.4,7.08,1.24,7.48,1.87",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,28.89c.18.17-.15,4.59-2.34,31.13-.32,3.85-.75,7.18-.96,7.4-.21.22-1.03-1.15-1.82-3.04-1.57-3.75-3.97-32.7-2.94-35.39.5-1.29,1.4-1.5,4.24-.97,1.98.37,3.7.76,3.81.87",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg31);
export default __webpack_public_path__ + "static/media/31.9765d95195f02d408b0634c80ef71bb8.svg";
export { ForwardRef as ReactComponent };